import { Optional, Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '@clooper/core';

@Pipe({ name: 'isUser' })
export class IsUserPipe implements PipeTransform {

  constructor(@Optional() private authService: AuthService) { }

  transform(id: string): boolean {
    return this.authService.getAuthorizedUser()?.id === id;
  }

}
